import { useContext } from "react";
import { ADMIN, READ_ONLY_ADMIN, SUBADMIN } from "constants/AppConstants";
import UserContext from "utils/context/UserContext";

// Single source of truth for admin-panel role checks. Components should
// read these flags instead of comparing user.roles / localStorage("userRole")
// directly, so a future role change only needs an update here.
//
// A Read-Only Admin can view/search/filter/export everywhere but must
// never see or trigger any create/edit/delete/approve/settings-change action.
const useAdminPermissions = () => {
  const { user } = useContext(UserContext) || {};
  const role = user?.roles;

  const isAdmin = role === ADMIN;
  const isSubadmin = role === SUBADMIN;
  const isReadOnlyAdmin = role === READ_ONLY_ADMIN;

  // Subadmin and Read-Only Admin both lose write access in most admin
  // views; kept as one flag so call sites don't repeat "either of these".
  const isWriteRestricted = isSubadmin || isReadOnlyAdmin;

  return {
    role,
    isAdmin,
    isSubadmin,
    isReadOnlyAdmin,
    isWriteRestricted,
    canEdit: !isReadOnlyAdmin,
  };
};

export default useAdminPermissions;
